import { render, staticRenderFns } from "./Faces.vue?vue&type=template&id=1947bdc4&"
import script from "./Faces.vue?vue&type=script&lang=js&"
export * from "./Faces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports